/* eslint-disable no-magic-numbers */
export const dev = {
	'URL': 'http://localhost:5000',
	'STRIPE_PK': 'pk_test_bxrU6TIW3CYFhuA5HITdEyvu'
};

export const production = {
	'URL': 'https://turing.vimma.co',
	'STRIPE_PK': 'pk_live_x9xgBNfS3HrHSvXvkgB8Pnyx'
};

console.log('Using ENV ' + process.env.REACT_APP_STAGE);
const config = process.env.REACT_APP_STAGE === 'production' ?
	production :
	dev;

if (process.env.REACT_APP_STAGE === 'production') {
	window.FbClientId = '198209477649988';
} else {
	window.FbClientId = '571766419950505';
}

const AVG_REACH = 0.44;
const LARGE_FOLLOWER_COUNT_COEFFICIENT = 0.00430159;

const avgFollowers = (values) => ((Number(values.minFolowers)) + (Number(values.maxFolowers))) / 2;


const avgPricePost = (values) => {
	const averageFollowers = ((Number(values.minFolowers)) + (Number(values.maxFolowers))) / 2;

	if (averageFollowers < 10000) {
		return (averageFollowers * 19 / 1000) > 62 ? 62 : (averageFollowers * 19 / 1000);
	}

	return averageFollowers * LARGE_FOLLOWER_COUNT_COEFFICIENT;
}
const avgPriceVideo = (values) => {
	const averageFollowers = ((Number(values.minFolowers)) + (Number(values.maxFolowers))) / 2;

	if (averageFollowers < 10000) {
		return ((averageFollowers) * 28.5 / 1000) > 93 ? 93 : ((averageFollowers) * 28.5 / 1000);
	}

	return averageFollowers * LARGE_FOLLOWER_COUNT_COEFFICIENT * 1.5;
}

const avgPriceOverall = (values) => {
	let pricePerPost = 0;
	let pricePerVideo = 0;

	if (values.promoteByPost) {
		pricePerPost = avgPricePost(values);
	}

	if (values.promoteByVideo) {
		pricePerVideo = avgPriceVideo(values);
	}
	debugger;
	// eslint-disable-next-line no-bitwise
	const avgPrice = (pricePerPost + pricePerVideo) / ((Boolean(pricePerPost) & Boolean(pricePerVideo)) + 1);

	return avgPrice;
}

const reach = (values) => {
	const avgFollowerss = Math.round(avgFollowers(values));
	const numberOfPosts = Math.round(values.budget / avgPriceOverall(values));

	return numberOfPosts * avgFollowerss * AVG_REACH;
};
const numberOfPeople = (values) => {
	return (values.budget / avgPriceOverall(values))
};


export default {
	"HEADERS": (bearer) => ({
		'Authorization': `Bearer ${bearer}`,
		'Accept': 'application/json',
		'Content-Type': 'application/json'
	}),
	'HEADERS_NOAUTH': {
		'Accept': 'application/json',
		'Content-Type': 'application/json'
	},
	'PRICE_CALCULATIONS': {
		reach,
		avgPricePost,
		avgPriceVideo,
		numberOfPeople
	},
	'PRICE': 12,
	...config
};